import React from 'react';
import { Outlet } from 'react-router-dom';
import { ContentBreadcrumbs } from '@/features/shell/BreadcrumbBar';

export function DeskLayout() {
  return (
    <div className="app-frame app-frame--shell-layout h-full flex flex-col min-h-0">
      <div className="app-frame-inner flex flex-1 min-h-0">
        <main className="app-content-box flex flex-col min-h-0 min-w-0">
          <ContentBreadcrumbs />
          <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
